import React from 'react';
import { BrandSymbol } from '../../../../../patterns/00-atoms/brand/brand-symbol.tsx';
import {
  FacebookLogo,
  InstagramLogo
} from '../../../../../patterns/00-atoms/social-media-logos/social-media-logos.tsx';

export const Footer: React.FunctionComponent = () => {
  return (
    <footer className="bg-sk-dark-blue p-8">
      <nav className="m-auto max-w-[940px]">
        <div className="grid md:grid-cols-3">
          <div className="text-center md:text-left">
            <FooterGroup>
              <FooterGroupHeadline>Über speisekarte</FooterGroupHeadline>
              <FooterLink href="https://www.speisekarte.de/nutzungsbedingungen">
                Nutzerbedingungen
              </FooterLink>
              <FooterLink href="https://www.speisekarte.de/agb">AGB</FooterLink>
              <FooterLink href="https://www.speisekarte.de/datenschutz">Datenschutz</FooterLink>
              <FooterLink href="https://www.speisekarte.de/#skPrivacy">Privatsphäre</FooterLink>
              <FooterLink href="https://www.speisekarte.de/about_us">Über uns</FooterLink>
              <FooterLink href="https://www.speisekarte.de/impressum">Impressum</FooterLink>
            </FooterGroup>
          </div>

          <div className="text-center">
            <FooterGroup>
              <FooterGroupHeadline>Erfahre mehr</FooterGroupHeadline>
              <FooterLink href="https://www.speisekarte.de/restaurantsuche">
                Restaurantsuche auf speisekarte.de
              </FooterLink>
              <FooterLink href="https://www.speisekarte.de/blog/">
                Der Blog von speisekarte.de
              </FooterLink>
            </FooterGroup>

            <FooterGroup>
              <FooterGroupHeadline>oder folge uns auf</FooterGroupHeadline>
              <FooterText>
                <div className="flex justify-center">
                  <FacebookLogo variant="white" />
                  <InstagramLogo variant="white" />
                </div>
              </FooterText>
            </FooterGroup>
          </div>

          <div className="text-center md:text-right">
            <FooterGroup>
              <FooterGroupHeadline>Extras</FooterGroupHeadline>
              <FooterLink href="https://www.speisekarte.de/restaurant_vorschlagen">
                Restaurant vorschlagen
              </FooterLink>
              <FooterLink href="https://www.speisekarte.de/faq">
                FAQ - Häufig gestellte Fragen
              </FooterLink>
              <FooterLink href="https://www.speisekarte.de/presse">Presse</FooterLink>
              <FooterLink href="https://www.speisekarte.de/alexa-skill">
                speisekarte.de ALEXA-Skill
              </FooterLink>
            </FooterGroup>
          </div>
        </div>
        <div className="text-center">
          <FooterGroup>
            <FooterText>
              <div className="flex justify-center">
                <BrandSymbol />
              </div>
            </FooterText>
            <FooterText>speisekarte.de - wo was wie schmeckt</FooterText>
            <FooterText>
              Version <strong className="ml-1">Live gf 𝘅 sk 🚀</strong>{' '}
              <small>
                <code>0.8</code>
              </small>
            </FooterText>
          </FooterGroup>
        </div>
      </nav>
    </footer>
  );
};

type FooterGroupProps = React.PropsWithChildren;

const FooterGroup: React.FunctionComponent<FooterGroupProps> = props => {
  return <ul className="mb-8">{props.children}</ul>;
};

type FooterGroupHeadlineProps = React.PropsWithChildren;

const FooterGroupHeadline: React.FunctionComponent<FooterGroupHeadlineProps> = props => {
  return <li className="mb-4 font-bold text-white">{props.children}</li>;
};

type FooterLinkProps = React.PropsWithChildren<{
  href?: string;
}>;

const FooterLink: React.FunctionComponent<FooterLinkProps> = props => {
  return (
    <li className="mb-4 text-sm text-gray-200 hover:text-gray-400">
      <a href={props.href}>{props.children}</a>
    </li>
  );
};

type FooterTextProps = React.PropsWithChildren;

const FooterText: React.FunctionComponent<FooterTextProps> = props => {
  return <li className="mb-4 text-sm text-gray-200">{props.children}</li>;
};
